// Island registry — maps a `data-island` name to a lazy loader that resolves to
// a module exporting `mount(node, props)`. Lazy `import()` keeps each island's
// libraries (e.g. Tiptap) out of the shell bundle until a page actually renders
// that island. Add one entry per kit island (rich text, multi-select, …).
//
// See app/frontend/entrypoints/islands.js (the scanner) and ADR 0003.
export const islandLoaders = {
  'rich-text': () => import('./rich_text/mount.jsx'),
  toast: () => import('./toast/mount.jsx'),
  palette: () => import('./palette/mount.jsx'),
  launcher: () => import('./launcher/mount.jsx'),
  reorder: () => import('./reorder/mount.jsx'),
  'segment-conditions': () => import('./segment_conditions/mount.jsx'),
  'journey-flow': () => import('./journey_flow/mount.jsx'),
  'bambora-card': () => import('./bambora_card/mount.js'),
  'guest-session-scheduler': () => import('./guest_session_scheduler/mount.jsx'),
  'template-preview': () => import('./template_preview/mount.jsx'),
  'callback-calendar': () => import('./callback_calendar/mount.jsx'),
  'data-chat': () => import('./data_chat/mount.jsx'),
}
